import MDBadge from "components/Basics/MDBadge";

/**
 * FAIQ Action butotn
 * @param {Object} props - Component properties
 * @param {string} [props.color="info"] - The color of the badge.
 * @param {string} [props.text=""] - The text to display inside the badge.
 * @param {JSX.Element} [props.icon=null] - The icon to display inside the badge.
 * @param {Function} [props.onClick=() => {}] - The function to call when the badge is clicked.
 * @returns {JSX.Element} The rendered component.
 */
const FaiqActionButton = ({ color = "info", text = "", icon = null }) => {
	return (
		<MDBadge
			className="asset-action-badge"
			size="xs"
			circular
			badgeContent={
				<span
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "center"
					}}
				>
					{icon}&nbsp;{text}
				</span>
			}
			container
			color={color}
			variant="contained"
			sx={{ width: "100%" }}
		/>
	);
};

export default FaiqActionButton;
